export default __webpack_public_path__ + "static/media/ali.9bf16017.jpeg";